import { render } from "./DebtRepayment.vue?vue&type=template&id=1830564f"
import script from "./DebtRepayment.vue?vue&type=script&lang=js"
export * from "./DebtRepayment.vue?vue&type=script&lang=js"

import "./DebtRepayment.vue?vue&type=style&index=0&id=1830564f&lang=css"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__